

export default {

    walk: function walk (path, ctxt) {

        if (!ctxt) {
            return;
        }
        let ps = path.split('.');
        if (ps.length === 1) {
            return ctxt[path];
        }

        let l = (ps && ps.length) || 0;
        for (let i = 0; i < l; i++) {
            ctxt = ctxt[ps[i]];
            if (!ctxt) {
                break;
            }
        }
        return ctxt;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/hash.js